
import React from 'react';
import PartnerOne from '../../assets/image/p1.png';
import PartnerTwo from '../../assets/image/p2.png';
import PartnerThree from '../../assets/image/p3.png';
import PartnerFour from '../../assets/image/p4.png';
import PartnerFive from '../../assets/image/p5.png';
import PartnerSix from '../../assets/image/p6.png';


 function Partner(props) {
    
    return (
<>

<div className="partnerSection">
      <h3 className='sectionHeading'>Partners</h3>
      <span className='headingAfterLine'></span>
      <div className="partnerWrap">
        <div className="partnerImage partnerOne">
            <img src={PartnerOne} alt="partnerImg" />
        </div>
        <div className="partnerImage">
            <img src={PartnerTwo} alt="partnerImg" />
        </div>
        <div className="partnerImage">
            <img src={PartnerThree} alt="partnerImg" />
        </div>
        <div className="partnerImage partnerFour">
            <img src={PartnerFive} alt="partnerImg" />
        </div>
        <div className="partnerImage">
            <img src={PartnerFour} alt="partnerImg" />
        </div>
        <div className="partnerImage">
            <img src={PartnerSix} alt="partnerImg" />
        </div>
      </div>
</div>

</>

    )

}

export default Partner
